// Route-based workspace tabs (paths are relative to /swiftboard/estimates/:estimateId).
export const WORKSPACE_TABS = [
  { path: "takeoff", label: "Takeoff" },
  { path: "equipment", label: "Equipment" },
  { path: "gen-conditions", label: "Gen Conditions" },
  { path: "materials", label: "Material List" },
  { path: "boq", label: "BOQ" },
  { path: "bid", label: "Bid Form" },
  { path: "history", label: "History" },
];
